$(function () {
	
	$(document).ready(function(){
		
		/* TOOLTIP init */	
		$('[data-toggle="tooltip"]').tooltip();
		
		/* SECTION 2 radio */
		$('#section-2-radio-2').click(function() {
			$('.option-2').show();
			$('.option-3').hide();
		});
		$('#section-2-radio-3').click(function() {
			$('.option-3').show();
			$('.option-2').hide();
		});
		
		/* SECTION 3 button tab */
		$('.section-3 button').click(function() {
			$('#section-3-button-1, #section-3-button-2').toggleClass('clicked unclicked');
		});
		$('#section-3-button-1').click(function() {
			$('.section-3 .option-1').show();
			$('.section-3 .option-2').hide();
		});
		$('#section-3-button-2').click(function() {
			$('.section-3 .option-2').show();
			$('.section-3 .option-1').hide();
		});
		
		/* SECTION 4 button tab */
		$('.section-4 button').click(function() {
			$('#section-4-button-1, #section-4-button-2').toggleClass('clicked unclicked');
		});
		$('#section-4-button-1').click(function() {
			$('.section-4 .option-1').show();
			$('.section-4 .option-2').hide();
		});
		$('#section-4-button-2').click(function() {
			$('.section-4 .option-2').show();
			$('.section-4 .option-1').hide();
		});
		
	});
	
	
	
})